import type { AppRole, AustralianState, JobTitle, OrgRole } from '@empower-safety/shared-types';
import { useQuery } from '@tanstack/react-query';
import { useApi } from './client.js';

export interface RosterTeamChip {
  id: string;
  name: string;
  slug: string;
  colour: string | null;
}

export interface RosterMember {
  user_id: string;
  email: string;
  display_name: string;
  avatar_url: string | null;
  phone_e164: string | null;
  last_seen_at: string | null;
  active: boolean;
  state: AustralianState | null;
  job_title: JobTitle | null;
  org_role: OrgRole;
  app_role: AppRole;
  // Modular capability flags. EditUserModal pre-fills its toggles from these;
  // is_admin is shown as a read-only badge (Admin is managed via Clerk).
  is_worker: boolean;
  is_monitor: boolean;
  is_admin: boolean;
  joined_at: string;
  active_check_in_id: string | null;
  active_check_in_scheduled_for: string | null;
  active_alarm_id: string | null;
  active_alarm_type: string | null;
  teams: RosterTeamChip[];
}

export function useRoster() {
  const api = useApi();
  return useQuery({
    queryKey: ['roster'],
    queryFn: () => api<{ members: RosterMember[] }>('/users'),
    refetchInterval: 30_000,
  });
}
